import PropTypes from 'prop-types'
import React from 'react'

import Formsy from 'formsy-react'
import { capitalize } from 'lodash'
import { FormSection, Row, Col, Button, Label, FormGroup, SheetFooter, SheetBody } from 'twyne-new.ui'

import CodeEditor from 'components/form/CodeEditor'

class EmailTemplateForm extends React.Component {
  state = {
    content: '',
  }

  componentWillMount() {
    const data = { ...this.props.data }
    if (data) {
      this.setState(data)
    }
  }

  handleValidSubmit = model => {
    model.is_admin = true
    this.props.onSubmit({ ...this.state, ...model })
  }

  render() {
    return <Formsy onValidSubmit={this.handleValidSubmit}>
      <SheetBody>
        <Row>
          <Col size='12'>
            <FormGroup>
              <Label>{this.state.typeTemplate ? capitalize(this.state.typeTemplate.split('_').join(' ')) : ''}</Label>
              <CodeEditor
                language='html'
                value={this.state.content}
                name="content"
                width="100%"
                height="300px"
              />
            </FormGroup>
          </Col>
        </Row>
      </SheetBody>
      <SheetFooter>
        <Button onClick={this.props.onCancel} variant='ghost'>Cancel</Button>
        <Button type="submit" color="accent">Save</Button>
      </SheetFooter>
    </Formsy>
  }
}

EmailTemplateForm.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  data: PropTypes.any,
}

export default EmailTemplateForm
